// @file Vuex Store for showing Confirmation Dialog (e.g. for deleting padlets)
import { DispatchableAction, ModalSize } from 'types'
import { Module } from 'vuex'

const generateCode = (): string =>
  Math.floor(Math.random() * 10000)
    .toString()
    .padStart(4, '0')

interface ConfirmationDialogState {
  isOpen: boolean
  isCodeProtected: boolean
  modalSize: ModalSize | null
  title: string
  body: string
  confirmationCode: string
  confirmButtonText: string
  cancelButtonText: string
  afterConfirmActions: DispatchableAction[]
  xAlertIcon: boolean | undefined
  isConfirmActionDanger?: boolean
  showConfirmButtonFirst?: boolean
  forceFullWidthButtons?: boolean
}

const blankState = (): ConfirmationDialogState => ({
  isOpen: false,
  isCodeProtected: false,
  modalSize: null,
  title: '',
  body: '',
  confirmationCode: generateCode(),
  confirmButtonText: '',
  cancelButtonText: '',
  afterConfirmActions: [],
  xAlertIcon: false,
  isConfirmActionDanger: false,
  showConfirmButtonFirst: false,
  forceFullWidthButtons: false,
})

const ConfirmationDialogModule: Module<ConfirmationDialogState, object> = {
  namespaced: true,
  state: blankState,
  mutations: {
    RESET_CONFIRMATION_DIALOG(state): void {
      Object.assign(state, blankState())
    },
    OPEN_CONFIRMATION_DIALOG(state, dialogState: ConfirmationDialogState): void {
      Object.assign(state, dialogState)
      state.isOpen = true
    },
    REGENERATE_CONFIRMATION_CODE(state): void {
      state.confirmationCode = generateCode()
    },
  },
  actions: {
    openConfirmationDialog({ commit }, params): void {
      commit('OPEN_CONFIRMATION_DIALOG', params)
    },
    executeConfirmActions({ dispatch }, actions: DispatchableAction[]): void {
      actions.forEach((actionHash): void => {
        dispatch(actionHash.type, actionHash.payload, { root: true })
      })
    },
    confirm({ commit, dispatch, state }, enteredCode = ''): void {
      if (!state.isCodeProtected || enteredCode === state.confirmationCode) {
        dispatch('executeConfirmActions', state.afterConfirmActions)
        commit('RESET_CONFIRMATION_DIALOG')
      } else {
        commit('REGENERATE_CONFIRMATION_CODE')
      }
    },
    cancel({ commit }): void {
      commit('RESET_CONFIRMATION_DIALOG')
    },
  },
}

export default ConfirmationDialogModule
export { ConfirmationDialogState }
